$(document).ready(function() {
    $('.js-autocookie').each(function() {
        const
            $el = $(this),
            key = $el.data('cookie-key'),
            value = $el.data('cookie-value');
        
        // Устанавливаем куку при клике
        $el.on('click', function() {
            setCookie('BX_' + key, value);
        });
    });
});